import { numberLocale } from '@/lib/money';
import { shortDate } from '@/lib/relative-time';

const DAY_MS = 86_400_000;

/** The last `n` calendar days ending today, as UTC `YYYY-MM-DD`, oldest first (the backend counts in UTC). */
export function lastDays(n: number, now: Date = new Date()): string[] {
  const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  return Array.from({ length: n }, (_, i) =>
    new Date(today - (n - 1 - i) * DAY_MS).toISOString().slice(0, 10)
  );
}

/** Midnight UTC at the start of the last `n` calendar days, as the naive timestamp the API takes. */
export function periodStart(n: number, now: Date = new Date()): string {
  return `${lastDays(n, now)[0]}T00:00:00`;
}

/** "Wed, 14 Oct" for the chart readout. */
export function formatDay(day: string, locale: string): string {
  return new Intl.DateTimeFormat(numberLocale(locale), {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  }).format(new Date(`${day}T00:00:00Z`));
}

export function formatRange(first: string, last: string, locale: string): string {
  return `${shortDate(first, locale)} – ${shortDate(last, locale, true)}`;
}
